import React from 'react';

export default function useWatchProp(prop, callback) {
  React.useEffect(() => {
    callback(prop);
  }, [prop]);
}
